import EventAlert from "./components/event_alert"

export default function EventsHandler(){
    let events = []
    let events_hist = []
    let event_alert = new EventAlert()
    initialize()

    this.addEvent = (event) =>{
        events.push(event)
    }

    function initialize(){
        let interval = setTimeout(checkEvents, 1000)
        function checkEvents(){
            let counter = 1000
            if(events.length > 0){
                showEvent(events[0])
                events.splice(0,1)

                counter *= 15
            }
            setTimeout(checkEvents, counter)
        }
    }
    function showEvent(event){
        if(event.type == 'new_rain_event'){
            showNewRainEvent(event)
        }
    }
    function showNewRainEvent(event){
        event_alert.showRainEvent({title: "NOVO EVENTO DE CHUVA", prefix: event.prefix, value: event.value, date_hour: event.date_hour})
    }

}